export const config = {
	validateOnBlur: true,
	btn: {
		icon: true
	}
};
